import { render, staticRenderFns } from "./cmpconsultanotasfor.vue?vue&type=template&id=95f2db60&"
import script from "./cmpconsultanotasfor.vue?vue&type=script&lang=js&"
export * from "./cmpconsultanotasfor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports